import { NotFoundPageComponent } from '@aston/foundation/components';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { AuthenticationIssuePageComponent } from './authentication-module/pages/authent-issue-page/authentication-issue-page.component';
import { MasterLayoutComponent } from './shared-module/layouts/master-layout/master-layout.component';
import { LoginPageComponent } from './authentication-module/pages/login-page/login-page.component';
import { AuthenticationGuard } from './authentication-module/guards';
import * as RoutesDefinitions from './routes-definitions';


const routes: Routes = [
	// Redirects to login page
	// {path: '', pathMatch: 'prefix', redirectTo: loginRoutePath},

	// Authentication process pages
	{
		path: `${RoutesDefinitions.LoginRoutePath}/:subscriptionKey/:superDebtorId/:signedHash`,
		component: LoginPageComponent,
		data: {titleTranslationKey: 'Login', layoutName: 'login'}
	},
	{
		path: RoutesDefinitions.AuthenticationIssueRoutePath,
		component: AuthenticationIssuePageComponent,
		data: {titleTranslationKey: 'Login', layoutName: 'authentication-issue'}
	},

	// Service pages
	{
		path: 'not-found', component: NotFoundPageComponent,
		data: {titleTranslationKey: 'NotFound'},
	},

	// Authenticated pages
	{
		path: '', component: MasterLayoutComponent,
		canActivate: [AuthenticationGuard],
		children: [
			{
				path: RoutesDefinitions.DunningActionsListRoutePath,
				loadComponent: () => import('./accounting-module/pages/dunning-actions-page/dunning-actions-page.component'),
				data: {
					titleTranslationKey: 'DunningActions',
					layoutName: 'Dunning'
				}
			},
			{
				path: RoutesDefinitions.DunningAccountingRoutePath,
				loadComponent: () => import('./accounting-module/pages/dunning-accounting-page/dunning-accounting-page.component'),
				data: {
					titleTranslationKey: 'Accounting',
					layoutName: 'Accounting'
				}
			},
			{
				path: RoutesDefinitions.DunningInvoicingRoutePath,
				loadComponent: () => import('./accounting-module/pages/dunning-invoicing-page/dunning-invoicing-page.component'),
				data: {
					titleTranslationKey: 'Invoicing',
					layoutName: 'Invoicing'
				}
			},
			{
				path: RoutesDefinitions.RequestsListRoutePath,
				loadComponent: () => import('./requests-module/pages/requests-list-page/requests-list-page.component'),
				data: {
					titleTranslationKey: 'Requests',
					layoutName: 'requests'
				}
			},
		]
	},

	// Default redirection
	{path: '**', redirectTo: RoutesDefinitions.AuthenticationIssueRoutePath}
];

@NgModule({
	imports: [RouterModule.forRoot(routes,
		{enableTracing: false} // <-- debugging purposes only
	)],
	exports: [RouterModule]
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AppRoutingModule {
}
